import { useEffect, useState } from 'react';
import Api from '../../../../inc/Api';
import Settings from '../../../../inc/Settings';

const userCache = {};
const pendingRequests = {};

const CreatedbyCustomCellRenderer = (props) => {
    const { value } = props;
    const [displayName, setDisplayName] = useState(userCache[value] || 'Loading...');

    useEffect(() => {
        let isMounted = true;

        const loadUserName = async (id) => {
            if (!id) {
                if (isMounted) setDisplayName('—');
                return;
            }

            if (userCache[id]) {
                if (isMounted) setDisplayName(userCache[id]);
                return;
            }

            if (pendingRequests[id]) {
                const name = await pendingRequests[id];
                if (isMounted) setDisplayName(name);
                return;
            }

            const fetchPromise = (async () => {
                try {
                    const api = Api;
                    api.setUserToken();
                    const response = await api.axios().get(`${Settings.apiUrl}/get_user/${id}`);

                    if (response?.status === 200 && response?.data?.data) {
                        const { first_name, last_name } = response.data.data;
                        const fullName = [first_name, last_name].filter(Boolean).join(' ') || '—';
                        userCache[id] = fullName;
                        return fullName;
                    } else {
                        userCache[id] = '—';
                        return '—';
                    }
                } catch {
                    userCache[id] = '—';
                    return '—';
                } finally {
                    delete pendingRequests[id];
                }
            })();

            pendingRequests[id] = fetchPromise;

            const name = await fetchPromise;
            if (isMounted) setDisplayName(name);
        };

        loadUserName(value);

        return () => {
            isMounted = false;
        };
    }, [value]);

    return <span>{displayName}</span>;
};

export default CreatedbyCustomCellRenderer;